import './index.scss'
import Loader from '../../../assets/images/spinner.svg'
import classNames from 'classnames'
import {useSelector} from 'react-redux'

const ContentLoader = ({width, height, className}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames({
            'content-loader': true,
            [className]: className,
            'dark': isDarkMode
        })}>
            <img width={width || 'auto'} height={height || 'auto'} src={Loader} alt="Pinghome"/>
        </div>
    )
}

export default ContentLoader
